

exports.__esModule = true;
exports.$SidepageAddCardRoute = undefined;

var _squid = require('squid');

require('xo-wallet-components/src/add-card/route');

require('./directive');

var $SidepageAddCardRoute = exports.$SidepageAddCardRoute = _squid.$ComponentRoute.extend('$SidepageAddCardRoute', {
    path: 'sidepageAddCard',
    directive: 'xo-sidepage-add-card-page',
    titleContent: 'asideHeader.addCard',
    trackingData: {
        templateName: 'tray/addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
                'version': 'member:%:tray'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks',
            promotion: 'promotion',
            'show-cancel': true
        }
    }]
});

angular.value("$SidepageAddCardRoute", $SidepageAddCardRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidepage-add-card/route.js
// module id = ./pages/xo-sidepage-add-card/route.js
// module chunks = 0